module.exports = __webpack_public_path__ + "static/img/third15.cb44d093.png";